// @flow

import ameSrc from './Brand_Ame.svg';
import mercadoPagoSrc from './Brand_MercadoPago.svg';
import payPalSrc from './Brand_PayPal.svg';
import picPaySrc from './Brand_PicPay.svg';

export function getBrandSource(brandName: string): string {
  switch (brandName) {
    case 'ame':
      return ameSrc;
    case 'mercadopago':
      return mercadoPagoSrc;
    case 'paypal':
      return payPalSrc;
    case 'picpay':
      return picPaySrc;
    default:
      throw new Error(`Brand "${brandName} not supported"`);
  }
}
